import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// actions
import { openTempUserModal } from '../../../Actions/users';

// styles
import './TempUserButton.css';

class TempUserButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: true
        }
    }

    handleCloseClick(e) {
        e.stopPropagation();

        this.setState({isOpen: false});
    }

    render() {
        if (!this.props || !this.props.isTempUser || !this.state.isOpen || !this.props.token) return null;

        return (
            <div className="temp-user-button-wrapper" style={{width: window.innerWidth}}>
                <div className="temp-user-button" onClick={() => this.props.openTempUserModal()}>
                    <p className="temp-user-text">
                        Click here to claim your account!
                    </p>
                    <div className="temp-user-close-btn" onClick={e => this.handleCloseClick(e)}>X</div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    isTempUser: state.users.isTempUser,
    token: state.users.token
});

TempUserButton.propTypes = {
    onClick: PropTypes.func,

    // state props
    isTempUser: PropTypes.bool,
    token: PropTypes.string,

    // state actions
    openTempUserModal: PropTypes.func
};

export default connect(mapStateToProps, { openTempUserModal })(TempUserButton);



// WEBPACK FOOTER //
// ./src/Components/Modals/TempUserButton/TempUserButton.js